//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    buttonText: String,
    link: String,
    filename: String
  },
  data () {
    return {
      visited: false
    }
  },
  methods: {
    visitLink () {
      this.visited = true
    }
  }
}

